import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { TrashIcon } from "src/pages/Reports/shared/icons";
import Checkbox from "src/pages/Reports/WorkPlaceReport/components/Checkbox";
import { favoriteFiltersListName } from "src/api/config";
import { deleteItem } from "src/modules/spItems/actions";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectItems } from "src/modules/spItems/selectors";

type Props = {
  opened: boolean;
  onApplyFilter: (filterId: string, type: "main" | "default", checked: boolean) => void;
  onUpdateDefault: (filterId: string, checked: boolean) => void;
  currentFavoriteId: string | null;
};

function BundlesModal({ opened, onApplyFilter, onUpdateDefault, currentFavoriteId }: Props) {
  const dispatch = useAppDispatch();
  const favoriteFiltersResponseData = useAppSelector((state) => selectItems(state, favoriteFiltersListName));

  const onCheck = (checked: boolean, id: string, type: "main" | "default" = "main") => {
    if (type === "main") {
      // При нажатии на основной чекбокс применяем фильтр
      onApplyFilter(id, type, checked);
    }

    if (type === "default") {
      onUpdateDefault(id, checked);
    }
  };

  const onDelete = (id: string) => {
    dispatch(
      deleteItem({
        listName: favoriteFiltersListName,
        ID: id,
        updateReducer: true,
      }),
    );
  };

  if (!opened || !favoriteFiltersResponseData?.length) return null;

  const bundles = favoriteFiltersResponseData.map((item) => {
    const parsedFilter = JSON.parse(item.DocumentsFilter);

    const parsedSubmitFilters = parsedFilter.filters || parsedFilter;

    return {
      id: item.ID.toString(),
      title: item.Title,
      collections:
        parsedSubmitFilters.collections.length > 0
          ? parsedSubmitFilters.collections.map((collection: any) => collection.title).join(", ")
          : "",
      departments:
        parsedSubmitFilters.departments.length > 0
          ? parsedSubmitFilters.departments.map((department: any) => department.title).join(", ")
          : "",
      workstations:
        parsedSubmitFilters.workstations.length > 0
          ? parsedSubmitFilters.workstations.map((workstation: any) => workstation.title).join(", ")
          : "",
      employees:
        parsedSubmitFilters.employees.length > 0
          ? parsedSubmitFilters.employees.map((employee: any) => employee.name).join(", ")
          : "",
      checked: item.ID.toString() === currentFavoriteId, // Помечаем как выбранный, если совпадает с текущим
      defaultChecked: item.isDefault || false,
    };
  });

  return (
    <FlexCol className="absolute w-[600px] gap-2.5 right-0 top-16 z-10 h-[calc(100dvh-76px)] overflow-y-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB]">
      {bundles.map((item) => (
        <div key={item.id} className="shadow-[0_10px_15px_0_rgba(5,_13,_29,_0.18)] p-5 bg-white rounded-lg">
          <FlexRow className="justify-between items-center mb-4">
            <Checkbox
              checked={item.checked}
              onChange={(checked) => onCheck(checked, item.id, "main")}
              title={item.title}
            />
            <button onClick={() => onDelete(item.id)}>
              <TrashIcon />
            </button>
          </FlexRow>
          <FlexCol className="pl-7 gap-2.5">
            {item.collections && (
              <span>
                Коллекция: <span className="text-black">{item.collections}</span>
              </span>
            )}
            {item.departments && (
              <span>
                Подразделение/Функция: <span className="text-black">{item.departments}</span>
              </span>
            )}
            {item.workstations && (
              <span>
                Рабочее место: <span className="text-black">{item.workstations}</span>
              </span>
            )}
            {item.employees && (
              <span>
                ФИО сотрудника: <span className="text-black">{item.employees.name}</span>
              </span>
            )}
            <Checkbox
              checked={item.defaultChecked}
              onChange={(checked) => onCheck(checked, item.id, "default")}
              title="Установить по умолчанию"
            />
          </FlexCol>
        </div>
      ))}
    </FlexCol>
  );
}

export default BundlesModal;
